import { Statistic } from '@components/MiscComponents/Statistic';
import { query, space } from '@design/templateFns';
import { FC } from 'react';
import styled from 'styled-components';
import { ContentWrapper, Eyebrow, StackedItem, StyledVerticalLineSeparator } from '../styles';

interface StackedStatsProps {
  header?: string;
  stats?: {
    key: string;
    statNumber: number;
    subheader: string;
    prepend?: string;
    append?: string;
  }[];
}

const StackedStats: FC<StackedStatsProps> = ({ header, stats }) => {
  return (
    <StackedItem>
      <StyledVerticalLineSeparator />

      <ContentWrapper>
        {header && <Eyebrow>{header}</Eyebrow>}

        <StatWrapper>
          {stats &&
            stats.map((stat) => {
              return (
                <Statistic
                  key={stat.key}
                  statNumber={stat.statNumber}
                  subheader={stat.subheader}
                  prepend={stat.prepend}
                  append={stat.append}
                />
              );
            })}
        </StatWrapper>
      </ContentWrapper>
    </StackedItem>
  );
};

export default StackedStats;

const StatWrapper = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-gap: ${space('margin')};

  @media screen and (${query.atLeast('desktop')}) {
    grid-template-columns: none;
    grid-template-rows: repeat(4, 1fr);
  }
`;
